export const IsValidToken = (token: string): boolean => {
  const splitted = token?.split('.');
  if (splitted?.length !== 3) return false;
  const payload = JSON.parse(atob(splitted[1]));
  const expirationDate = new Date(payload.exp * 1000);
  const now = new Date();
  return expirationDate > now;
};
export const IsValidRefreshToken = (token: string): boolean => {
  const splitted = token?.split('.');
  if (splitted?.length !== 3) return false;
  const payload = JSON.parse(atob(splitted[1]));
  const expirationDate = new Date(payload.exp * 1000);
  const now = new Date();
  return expirationDate > now && payload.refresh === true;
};
